import OtherOrganizationsSettings from './OtherOrganizationsSettings';

export default OtherOrganizationsSettings;
